import{gql as t}from"@apollo/client";const e=t`
  query getNextOrPreviousContentPage(
    $contentPageId: Int!
    $navigationDirection: EContentPageNavigationDirection!
    $userFlowStepTrackId: Int!
  ) {
    contentPage {
      getNextOrPreviousPage(currentPageId: $contentPageId, navigation: $navigationDirection, trackingId: $userFlowStepTrackId) {
        id
        isCompleted(stepTrackingId: $userFlowStepTrackId)
        title
        url
      }
    }
  }
`;export{e as GET_NEXT_OR_PREVIOUS_CONTENT_PAGE_QUERY};
//# sourceMappingURL=useContentPageNavigation.graphql.js.map
